import isEmpty from 'lodash/isEmpty';
import {
  validateRange,
  validateRequired,
  validateZipCode,
  validatePositiveMoney,
} from '../../../../../utils/validations';
import messages from '../messages';

const validate = (
  values: Object = {},
  { intl, flags, isPHFloorPlan, isHUDFloorPlan }: Object,
) => {
  const errors = {};

  const {
    unitFloorLevel,
    zipCode,
    quotingRentAmount,
    PHUnitNumber,
    hudNumber,
  } = values;

  const { removeUnitFloorLevelRestrictions } = flags;

  ['streetAddress1', 'city', 'state'].forEach((fieldName) => {
    if (!validateRequired(fieldName, values)) {
      errors[fieldName] = intl.formatMessage(messages.required);
    }
  });

  if (
    !removeUnitFloorLevelRestrictions &&
    unitFloorLevel &&
    !validateRange(unitFloorLevel, 1, 25)
  ) {
    errors.unitFloorLevel = intl.formatMessage(messages.outOfRangeFloorLevel);
  }

  if (
    (zipCode && !validateZipCode(zipCode)) ||
    !validateRequired('zipCode', values)
  ) {
    errors.zipCode = intl.formatMessage(messages.invalidZipCode);
  }

  if (isPHFloorPlan && !isEmpty(PHUnitNumber ?? '')) {
    const phUnitNumberLength = PHUnitNumber.length;
    if (phUnitNumberLength > 10) {
      errors.PHUnitNumber = intl.formatMessage(
        messages.invalidPHUnitNumberLength,
      );
    }
  }

  const trimmedHudNumber = (hudNumber ?? '').trim();
  if (isHUDFloorPlan && !isEmpty(trimmedHudNumber)) {
    const hudRegex = /^[a-zA-Z0-9 \-/.]+$/;
    if (trimmedHudNumber.length > 15 || !hudRegex.test(trimmedHudNumber)) {
      errors.hudNumber = intl.formatMessage(messages.invalidHUDUnitNumber);
    }
  }

  // Validate quotingRentAmount using validatePositiveMoney and max value check
  if (!isEmpty(quotingRentAmount ?? '')) {
    const numValue = parseFloat(quotingRentAmount);
    if (!validatePositiveMoney(quotingRentAmount) || numValue > 999999.99) {
      errors.quotingRentAmount = intl.formatMessage(
        messages.invalidQuotingRentAmount,
      );
    }
  }

  return errors;
};

export default validate;
